import { create } from "zustand";

const useServiceStore = create((set) => ({
  serv: "",
  view_only: false,
  setService: (serv,view) => set({ serv,view_only:view }),
}));

export default useServiceStore;
